import React from "react";
import benefitImage from "../../images/Svg/benefit.svg";
import FeatureData from "../Feature/Feature.data";
const parse = require("html-react-parser");

export default function WhySetu() {
  return (
    <section className="why-section py-[86px]">
      <div className="container mx-auto px-6 sm:px-6 md:px-16">
        <div>
          <h1 className="font-bold text-[30px] lg:text-[48px] ">
            Setu is a one-stop free solution to{" "}
            <span className="text-blue">shift content from web2 to DeSo</span>{" "}
            seamlessly
          </h1>
        </div>
        <div className="grid md:grid-cols-2 items-center mt-[24px]">
          <div>
            <p className="text-[18px] md:text-[24px] text-[#585858] mb-[30px] md:mb-[40px]">
              We offer the following services to help you bring your best work
              to DeSo
            </p>
            {FeatureData.map((data, index) => (
              <div
                key={index}
                className="px-[24px] py-[16px] flex items-center mb-[16px] bg-[#ffff] rounded-[8px] md:w-[430px] md:h-[141px]"
              >
                <div>
                  <img src={data?.icon} alt="" />
                </div>

                <div className="ml-4 text-justify">
                  <h1 className="text-[20px] md:text-[24px] font-[600] ">
                    {data?.title}
                  </h1>
                  <p className="leading-[24px] text-[13px] mt-[8px] md:text-[16px] text-[#161616]">
                    {parse(data.description)}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div>
            <img src={benefitImage} alt="" />
          </div>
        </div>
      </div>
    </section>
  );
}
